<div class="footer-container">
  <div class="footer-content">
    <div class="copyright">{{ footerData?.copyright }}</div>
    <div class="footer-links">
      <app-link *ngFor="let link of footerData?.links" [to]="link.url">
        {{ link.label }}
      </app-link>
      <app-link style="display: none;" id="cpra_button">
        Privacy Choices
      </app-link>
    </div>
  </div>
</div>
